import { TEDCustomNumberDisplayer } from './TEDCustomNumberDisplayer';
import { TEDParseNumberMode } from '../FormatterTypes';

class TEDDisplayInt extends TEDCustomNumberDisplayer {
  public static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayInt;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmInteger;
  }
}

export { TEDDisplayInt };
